<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Tue, 20 Feb 2024 07:54:36 Central Standard Time, Mexico City, Mexico
  - Copyright (c) 2024, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { Link, router } from "@inertiajs/vue3";
import { reactive, inject } from "vue";
import MenuPopoverList from "@/Layouts/Grp/MenuPopoverList.vue";
import TopBarSelectButton from "@/Layouts/Grp/TopBarSelectButton.vue";
import { Menu, MenuItems, MenuItem } from "@headlessui/vue";
import { Disclosure } from "@headlessui/vue";
import Button from "@/Components/Utils/Button.vue";
import { trans } from "laravel-vue-i18n";
import Image from "@/Components/Utils/Image.vue";
import { usePage } from "@inertiajs/vue3";
import { faChevronDown } from "@far";
import { } from "@fal";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import MenuTopRight from "@/Layouts/Grp/MenuTopRight.vue";
import TopBarDropdownScope from "@/Layouts/Grp/TopBarDropdownScope.vue";
import { layoutStructure } from "@/Composables/useLayoutStructure";
import { faBallot } from "@fas";
import ScreenWarning from "@/Components/Utils/ScreenWarning.vue";

library.add();

defineProps<{
    sidebarOpen: boolean
    logoRoute: string
    urlPrefix: string
}>();

defineEmits<{
    (e: "sidebarOpen", value: boolean): void
}>();

// To handle skeleton image in dropdown
const imageSkeleton: { [key: string]: boolean } = reactive({});

const layoutStore = inject("layout", layoutStructure);

console.log("environment:", usePage().props.environment);

</script>

<template>
    <nav class="fixed top-0 z-[21] w-full bg-gray-50 text-gray-700">
        <ScreenWarning v-if="layoutStore.app.environment === 'staging'" class="relative top-0" />

        <div class="px-0">
            <div class="flex h-11 lg:h-10 flex-shrink-0">
                <div class="flex">
                    <!-- Mobile: Hamburger -->
                    <button class="block md:hidden w-10 h-10 relative focus:outline-none"
                        @click="$emit('sidebarOpen', !sidebarOpen)">
                        <span class="sr-only">Open sidebar</span>
                        <div class="block w-5 absolute left-1/2 top-1/2   transform  -translate-x-1/2 -translate-y-1/2">
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-200 ease-in-out"
                                :class="{ 'rotate-45': sidebarOpen, ' -translate-y-1.5': !sidebarOpen }"></span>
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-100 ease-in-out"
                                :class="{ 'opacity-0': sidebarOpen }"></span>
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-200 ease-in-out"
                                :class="{ '-rotate-45': sidebarOpen, ' translate-y-1.5': !sidebarOpen }"></span>
                        </div>
                    </button>

                    <!-- App Title: Image and Title -->
                    <div class="overflow-hidden relative flex flex-1 items-center justify-center md:justify-start transition-all duration-300 ease-in-out"
                        :class="[layoutStore.leftSidebar.show ? 'md:w-48 md:pr-4' : 'md:w-12']" :style="{
                            'background-color': layoutStore.app.theme[0],
                            'color': layoutStore.app.theme[1],
                            'border-bottom': `1px solid ${layoutStore.app.theme[2]}3F`
                        }">
                            <Link
                                :href="route('home')"
                                class="hidden md:flex flex-nowrap items-center h-full overflow-hidden gap-x-1.5 transition-all duration-200 ease-in-out"
                                :class="[layoutStore.leftSidebar.show ? 'py-1 pl-4' : 'pl-2.5 w-full']">
                                <img
                                    src="/logo.svg"
                                    class="aspect-square h-7 bg-white rounded" />
                                <Transition name="slide-to-left">
                                    <p v-if="layoutStore.leftSidebar.show"
                                        class="text-lg bg-clip-text font-bold whitespace-nowrap leading-none lg:truncate">
                                        Dita Kurnia
                                    </p>
                                </Transition>
                            </Link>
                    </div>
                </div>

                <div class="flex items-center w-full justify-between pr-6 space-x-3 border-b border-gray-200">
                    <!-- Section: Dropdown + subsections -->
                    <div class="flex items-center gap-x-2 pl-2">

                        <!-- Section: Subsections (Something will teleport to this section) -->
                        <div class="flex h-full" id="TopBarSubsections">
                        </div>

                    </div>

                    <!-- Section: Search, Notification, Profile -->
                    <MenuTopRight :urlPrefix="urlPrefix" />
                </div>
            </div>
        </div>
    </nav>
</template>
